import React from "react";
import I18n from "../../../i18n/";
import { CounselingGeneric } from "./index";
import ReportAction from "../../../actions/ReportAction";
import { CounselingSupportGraph } from "../../../constants/supportGraph";
import { TargetValueType } from "../CompareValuePanel";

export default (props)=>(
	<CounselingGeneric 
		typeKey={CounselingSupportGraph.Feedback}
		subHeader={I18n.t("visit_feedback")}
		fetchMain={ReportAction.fetchCounFeedback}
		getAutoSelectItem={(items)=>{
			const types = Object.keys(items);
			let lastReadKey = undefined;
			let pick = {type:types[0], value:undefined};
			for(let i=0;i<types.length && pick.value === undefined;i++){
				const t = types[i];
				const tKeys = Object.keys(items[t]);
				for(let j=0;j<tKeys.length && pick.value === undefined;j++){
					const tk = tKeys[j];
					if(tk!=="null" && items[t][tk]>0){
						pick.type = t;
						pick.value = tk;
					}
					lastReadKey = tk;
				}
			}
			if(pick.value===undefined){
				pick.value = lastReadKey;
			}
			return pick;
		}}
		mainSelectToFilterValue={(typeKey, typeValue)=>{
			const { type, value } = typeValue;
			return {type, value};
		}}
		// exclude={[CounselingSupportGraph.Feedback]}
	/>
);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Counseling/CounselingVisitFeedback.js